import {keys, map} from 'lodash';
import {ReactNode, useEffect, useState} from 'react';
import {Helmet} from 'react-helmet-async';

export function usePrerenderMetaTags<T>(
  data: T,
  generateTagsMap: (data: T) => {[key: string]: string | null | undefined},
) {
  const [metaTags, setMetaTags] = useState<ReactNode>(null);

  useEffect(() => {
    if (data) {
      const tagsMap = generateTagsMap(data);
      setMetaTags(
        <Helmet>
          {map(keys(tagsMap), (key) => (
            <meta key={key} name={key} content={tagsMap[key] || ''} />
          ))}
        </Helmet>,
      );
      // @ts-ignore
      window.prerenderReady = true;
    } else {
      // @ts-ignore
      window.prerenderReady = false;
    }
  }, [data, generateTagsMap]);

  return metaTags;
}
